import { MAX_RECURSION_DEPTH_MEDIUM } from "./common_utils"
import { safeJsonParse } from "./safe_json_parse"

export const cloneImmutable = <T>(value: T, depth = MAX_RECURSION_DEPTH_MEDIUM, options?: {
  method?: `json_parse` | `loop`
}): T => {
  if (depth <= 0 || typeof value !== `object` || value === null)
    return value

  if (options?.method === `loop`) {
    if (Array.isArray(value))
      return value.map(item => cloneImmutable(item, depth - 1, options)) as any

    const clonedObject = {} as T

    for (const key in value) {
      if (Object.prototype.hasOwnProperty.call(value, key))
        clonedObject[key] = cloneImmutable(value[key], depth - 1, options)
    }

    return clonedObject
  }

  if (Array.isArray(value))
    return value.map(item => cloneImmutable(item, depth - 1, options)) as any

  return safeJsonParse(value) ?? value
}
